import {
    HttpInterceptor, HttpRequest, HttpHandler,
    HttpSentEvent, HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent, HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthenticationService } from "./authentication.service";
import { BehaviorSubject, Observable, throwError } from "rxjs";
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import { CurrentUser } from "./../../models";
import { Router } from "@angular/router";
@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private authService: AuthenticationService, private router: Router) { }

    isRefreshingToken: boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
        if(request.url.includes('api/CustomerLogin') || request.url.includes('api/LoginReadonly')){
            return next.handle(request);
        }
        return next.handle(this.addTokenToRequest(request, this.authService.getAuthToken()))
            .pipe(
                catchError(err => {
                    if (err instanceof HttpErrorResponse) {
                        switch ((<HttpErrorResponse>err).status) {
                            case 401:
                                return this.handle401Error(request, next);
                            case 405: {
                                alert("You are not authorized to do this action!")
                                return throwError(err);
                            }
                        }
                        if (err.url.includes('RefreshToken')) {
                            return <any>this.authService.logoutUser(this.router);
                        }
                    } else {
                        return throwError(err);
                    }
                    return throwError(err);
                }));
    }

    private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
        return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {

        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            return this.authService.refreshToken()
                .pipe(
                    switchMap((user: CurrentUser) => {
                        if (user) {
                            this.tokenSubject.next(user.access_token);
                            return next.handle(this.addTokenToRequest(request, user.access_token));
                        }

                        return <any>this.authService.logoutUser(this.router);
                    }),
                    catchError(err => {
                        if (err instanceof HttpErrorResponse) {
                            return <any>this.authService.logoutUser(this.router);
                        }
                    }),
                    finalize(() => {
                        this.isRefreshingToken = false;
                    })
                );
        } else {

            return this.tokenSubject
                .pipe(filter(token => token != null),
                    take(1),
                    switchMap(token => {
                        return next.handle(this.addTokenToRequest(request, token));
                    }));
        }
    }
}